import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const inputCls =
  "w-full bg-[#0C0C12] border border-[#282836] rounded-xl px-4 py-3 text-[#F4F4F8] placeholder:text-[#63637A] focus:outline-none focus:border-[#FF5500] transition-colors text-sm";

export const SettingsPanel = () => {
  const [text, setText] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/disclaimer").then(({ data }) => setText(data.text)).catch(() => setText(""));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/settings/disclaimer", { text });
      setText(data.text);
      toast.success("Disclaimer updated — live on the site now");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  if (text === null) {
    return (
      <div className="flex justify-center py-24">
        <Loader2 className="w-8 h-8 animate-spin text-[#FF5500]" />
      </div>
    );
  }

  return (
    <div data-testid="settings-panel" className="max-w-2xl">
      <form data-testid="disclaimer-form" onSubmit={save} className="bg-[#12121A] border border-[#282836] rounded-3xl p-8">
        <h2 className="font-display text-xl font-bold mb-2">Legal disclaimer</h2>
        <p className="text-sm text-[#63637A] mb-6">
          This text shows in the band above the footer on every page. Changes go live immediately.
        </p>
        <textarea
          data-testid="disclaimer-text-input"
          rows={5}
          required
          value={text}
          onChange={(e) => setText(e.target.value)}
          className={`${inputCls} resize-none`}
        />
        <button
          data-testid="disclaimer-save-button"
          type="submit"
          disabled={saving}
          className="btn-brand mt-5 inline-flex items-center gap-2 bg-[#FF5500] text-[#08080C] font-semibold px-6 py-3 rounded-xl disabled:opacity-60"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Save disclaimer
        </button>
      </form>
    </div>
  );
};
